import { render, staticRenderFns } from "./Final1.vue?vue&type=template&id=45604ee7&scoped=true"
import script from "./Final1.vue?vue&type=script&lang=js"
export * from "./Final1.vue?vue&type=script&lang=js"
import style0 from "./Final1.vue?vue&type=style&index=0&id=45604ee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45604ee7",
  null
  
)

export default component.exports